<div mdbModal #verAddEditRutasModal="mdb-modal" class="modal fade" id="dvModalAsignarCamionRutas" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [formGroup]="formRuta"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          {{!recorridoSeleccionado?'Crear Ruta': 'Modificar Ruta Nro.' + recorridoSeleccionado.recorrido_codigo}}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="verAddEditRutasModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body justify-content-between">
          <div class="row">
            <div class="col">
              <div class="md-form" style="max-width: 200px;">
                <mdb-date-picker [inline]="true" #dpFechaMain name="fechaMain" [placeholder]="'Fecha'" required
                  formControlName="fechaMain">
                </mdb-date-picker>
              </div>
              <div class="md-form" style="max-width: 300px; display: flex; align-items: center;">

                <mdb-select (click)="setCamion()" [options]="optionsCamion" [multiple]="false" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Seleccionar Patente" formControlName="camion">
                </mdb-select>
                <div *ngIf="loadingCamiones" class="spinner-border spinner-border-sm" role="status">
                </div>
                <label>Patente</label>
              </div>
              <div class="md-form" *ngIf="camion" style="max-width: 300px;">
                <h6 class="text-info" style="width: 300px">
                  Peso : {{camion.peso_maximo}}
                </h6>
                <h6 class="text-info" style="width: 300px">
                  Volumen : {{camion.volumen}}
                </h6>
              </div>
              <div class="md-form" style="display: flex; align-items: center;">
                <mdb-select style="width: 300px" (click)="setChofer()" [options]="optionsChofer" [multiple]="false"
                  [filterEnabled]="true" [highlightFirst]="false" placeholder="Seleccionar Chofer"
                  formControlName="chofer">
                </mdb-select>
                <div *ngIf="loadingChoferes" class="spinner-border spinner-border-sm" role="status">
                </div>
                <label>Chofer</label>
              </div>
              <div class="md-form" *ngIf="chofer">
                <h6 class="text-info" style="width: 300px">
                  Rut : {{chofer.value}}
                </h6>
                <h6 class="text-info" style="width: 300px">
                  Telefono : {{(chofer.fono1 ? chofer.fono1 : 'Sin Información')}}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="CerrarModal()" mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          (click)="addRuta(); verAddEditRutasModal.hide();">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>
